<template>
  <div>
    <BaseTopLine>
      <div class="d-flex gap-10 align-items-center">
        <div class="btn btn-sm btn-primary" @click="openModalForCreate('bookPhonesModal')">
          Добавить
        </div>
        <div class="btn btn-sm btn-opposite" @click="deleteActionAndModal">
          Удалить
        </div>
      </div>
    </BaseTopLine>
    <div class="p-20">
      <BasePagination :page-count="numPages" :page-range="3" :margin-pages="2" :break-view-class="'d-none'"
        :click-handler="clickLoadData" :prev-text="'Назад'" :next-text="'Далее'"
        :container-class="'pagination pagination-sm'" :page-class="'page-item'" :pageLinkClass="'page-link'">
      </BasePagination>

      <BaseReuseTable :props-data="BookPhonesData" :props-columns-setting="fieldsTableBookPhones"
        :selectRowActivateFlag="true" :modalActivateFlag="true" nameForAction="bookPhonesModal"
        v-if="BookPhonesLoadStatus == 'success'">
      </BaseReuseTable>
    </div>
    <Teleport to="body">
      <Modal nameForAction="bookPhonesModal" @closeModal="closeModal">
        <div class="p-10">
          <BaseInput placeholder="" title="" @onInput="updateValue" :value="dataForModal.book_contacts__name"
            name-sign="Наименование" input-name="book_contacts__name">
          </BaseInput>
          <BaseInput placeholder="" title="" @onInput="updateValue" :value="dataForModal.book_contacts__pone1"
            name-sign="Телефон" input-name="book_contacts__phone1">
          </BaseInput>
          <BaseInput placeholder="" title="" @onInput="updateValue" :value="dataForModal.book_contacts__description"
            name-sign="Описание" input-name="book_contacts__description">
          </BaseInput>
          <div class="d-flex gap-10 mt-15">
            <div class="btn btn-sm btn-primary" @click="sendDataFromModal">
              {{ dataLang.form_btn__btn_save }}
            </div>
            <div class="btn btn-sm btn-opposite" @click="btnHandlerCloseModal">
              {{ dataLang.form_btn__btn_caneсl }}
            </div>
          </div>
        </div>
      </Modal>
      <Modal nameForAction="acceptDelete">
        <p class="text-center">{{ dataLang.confirm_dialog_delete }}</p>
        <div class="d-flex justify-content-center mt-10">
          <div class="btn btn-sm btn-danger" @click="deleteRow('acceptDelete')">
            Да
          </div>
        </div>
      </Modal>
    </Teleport>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Modal from '@/components/Modals.vue'
import EventBus from '@/event-bus.js'
export default {
  components: {
    Modal
  },

  props: {},
  data() {
    return {
      updatedValues: {},
      dataForModal: {},
      editData: {},
      activeSelectRow: null
    }
  },
  methods: {
    clickLoadData(numPage) {
      this.getBookPhonesAll({
        params: {
          limit: 10,
          page: numPage
        }
      })
    },
    openModalForCreate(nameModal) {
      EventBus.$emit('openModal', {
        data: null,
        nameForAction: nameModal,
        mode: 'create'
      })
    },

    deleteActionAndModal() {
      if (this.activeSelectRow) {
        EventBus.$emit('openModal', {
          data: null,
          nameForAction: 'acceptDelete',
          mode: 'create'
        })
      } else {
        this.$toast.error('Вы не выбрали ни одного поля', { duration: 5000 })
      }
    },
    deleteRow(nameModal) {
      this.deleteBookPhonesData(this.activeSelectRow)
      this.activeSelectRow = null
      EventBus.$emit('closeModal', { nameForAction: nameModal })
    },

    sendDataFromModal() {
      if (this.dataForModal.book_contacts__id) {
        this.editBookPhonesMultiple({
          id: this.dataForModal.book_contacts__id,
          dataEdit: this.updatedValues
        })
        EventBus.$emit('closeModal', { nameForAction: 'bookPhonesModal' })
      } else {
        this.createBookPhonesData(this.updatedValues)
        // this.$refs[bookPhonesModal].$el.querySelectorAll('input').forEach(elem => {
        //     elem.value = ''
        // })

        EventBus.$emit('closeModal', { nameForAction: 'bookPhonesModal' })
      }
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value
    },

    prepareKeysForModal(payloadData) {
      this.updatedValues = {}
      this.dataForModal = {}
      if (!payloadData) {
        for (const key in this.BookPhonesData[0]) {
          this.dataForModal[key] = null
        }
      } else {
        this.dataForModal = Object.assign({}, payloadData)
      }
    },

    closeModal(data) {
      this.activeSelectRow = {}
      this.dataForModal = {}
      // this.$refs[data.nameForAction].$el.querySelectorAll('input').forEach(element => {
      //     element.value = ''
      // })
    },
    btnHandlerCloseModal(nameModal) {
      EventBus.$emit('closeModal', { nameForAction: 'bookPhonesModal' })
    },

    ...mapActions('bookPhonesModule', [
      'getBookPhonesAll',
      'createBookPhonesData',
      'editBookPhonesMultiple',
      'deleteBookPhonesData',
      'setBookPhonesRoute'
    ])
  },
  mounted() {
    EventBus.$on('openModal', (payload) => {
      this.editData = payload.data

      this.prepareKeysForModal(payload.data)
    })
    EventBus.$on('selectTableRows', (payload) => {
      this.activeSelectRow = payload.data.book_BookPhones__id
    })
    EventBus.$on('deselectTableRows', (payload) => {
      this.activeSelectRow = null
    })
  },

  created() {
    this.setBookPhonesRoute(this.$router.currentRoute.path)
    this.getBookPhonesAll({ params: { page: 1, limit: 10 } })
  },
  computed: {
    ...mapState('bookPhonesModule', [
      'BookPhonesData',
      'BookPhonesLoadStatus',
      'paginationBookPhonesStateParams'
    ]),
    ...mapState('translationModule', ['dataLang']),
    ...mapGetters('bookPhonesModule', ['numPages']),

    fieldsTableBookPhones() {
      return [
        {
          title: 'Наименование',
          field: 'book_contacts__name',
          headerFilter: 'input'
        },
        {
          title: 'Телефон',
          field: 'book_contacts__phone1',
          headerFilter: 'input'
        },
        {
          title: 'Описание',
          field: 'book_contacts__description',
          headerFilter: 'input'
        }
      ]
    }
  }
}
</script>
